import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { concatMap, finalize, tap } from 'rxjs/operators';

@Injectable()
export class LoadingViewService {
  loading$: Observable<boolean>;
  private _loading: BehaviorSubject<boolean>;

  constructor() {
    this._loading = new BehaviorSubject(false);
    this.loading$ = this._loading.asObservable();
  }

  showLoaderUntilCompleted<T>(obs$: Observable<T>): Observable<T> {
    return of(null).pipe(
      tap(() => this.loadingOn()),
      concatMap(() => obs$),
      finalize(() => this.loadingOff()),
    );
  }

  loadingOn(): void {
    this._loading.next(true);
  }

  loadingOff(): void {
    this._loading.next(false);
  }
}
